import React, {Fragment, useEffect, useState} from 'react'
import {
    reqGnVehicleTypes, reqGnGoodsTypes, reqGnPackageTypes, getGnOrder, reqCreateGnOrder, reqUpdateGnOrder,
} from '../../api'
import {Form, Input, Button, DatePicker, message, Radio, Checkbox, Icon, InputNumber,} from 'antd';
import './domestic.less'
import moment from 'moment';
import 'moment/locale/zh-cn';
import Address from "./address";
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
import {convertToCheckboxes} from "../../components/checkboxes";
import {convertToRadios} from "../../components/radios";
import {range, setDefaultAddrFlag} from "../../utills/common";
import ContractModal from "./contract-modal";

const AuthFormItem = authorizeBase(Form.Item)
moment.locale('zh-cn');

function DomesticOrder(props) {
    const [order, setOrder] = useState({});
    const {getFieldDecorator, setFieldsValue} = props.form;
    const [startAdressPos, setStartAdressPos] = useState([]);
    const [endAdressPos, setEndAdressPos] = useState([]);
    const [vehicleTypeValue, setVehicleTypeValue] = useState([]);
    const [goodsTypeOther, setGoodsTypeOther] = useState(true);
    //数据源
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [goodsTypes, setGoodsTypes] = useState([]);
    const [packageTypes, setPackageTypes] = useState([]);
    //合同弹框
    const [visibleContract, setVisibleContract] = useState(false);
    useEffect(() => {
        getVehicleTypes()
        getGoodsTypes()
        getPackageTypes()
        if (props.location.state) {
            const orderId = props.location.state.orderId;
            if (orderId) {
                getOrder(orderId)
            } else {
                addAddr('start')
                addAddr('end')
                changeGoodsTypes([])
            }
        } else {
            addAddr('start')
            addAddr('end')
            changeGoodsTypes([])
        }
    }, []);
    const getVehicleTypes = async () => {
        let result = await reqGnVehicleTypes();
        if (result.code == 200) {
            setVehicleTypes(result.data)
        } else {
            message.error(result.message)
        }
    };
    const getGoodsTypes = async () => {
        let result = await reqGnGoodsTypes();
        if (result.code == 200) {
            setGoodsTypes(result.data)
        } else {
            message.error(result.message)
        }
    };
    const getPackageTypes = async () => {
        let result = await reqGnPackageTypes();
        if (result.code == 200) {
            setPackageTypes(result.data)
        } else {
            message.error(result.message)
        }
    };
    const getOrder = async (id) => {
        let result = await getGnOrder(id)
        if (result.code === 200) {
            const data = {...result.data};
            setDefaultAddrFlag(data.startAdressPos, data.originCity)
            setStartAdressPos(data.startAdressPos)
            setDefaultAddrFlag(data.endAdressPos, data.destinationCity)
            setEndAdressPos(data.endAdressPos)
            data.deliveryEstimateDt = data.deliveryEstimateDt ? moment(data.deliveryEstimateDt) : null
            setOrder(data);
            //货物类型选其他 展示货物类型名称
            changeGoodsTypes(data.goodsTypes || [])
            props.form.setFieldsValue(data)
        } else {
            message.error(result.message)
        }
    }
    const handleSaveSubmit = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                if (err.startAdressPos) {
                    err.startAdressPos.forEach(o => {
                        message.error(o.contackPhone.errors[0].message)
                    })
                }
                if (err.endAdressPos) {
                    err.endAdressPos.forEach(o => {
                        message.error(o.contackPhone.errors[0].message)
                    })
                }
                if (err.goodsName) {
                    message.error(err.goodsName.errors[0].message)
                }
                return
            }
            //新增时，车辆校验及数据组装
            if (!order.id) {
                //没有填写地址时，提示填写地址
                const errorArray = []
                if (!values.startAdressPos || values.startAdressPos.length === 0) {
                    errorArray.push('至少填写一个起运地地址')
                }
                if (!values.endAdressPos || values.endAdressPos.length === 0) {
                    errorArray.push('至少填写一个目的地地址')
                }
                //多个地址时，只能选一辆车
                if ((values.startAdressPos && values.startAdressPos.length > 1) || (values.endAdressPos && values.endAdressPos.length > 1)) {
                    let total = 0
                    if (values.vehicleNums) {
                        values.vehicleNums.forEach((num) => {
                            total += num;
                        })
                    }
                    if (values.vehicleTypes > 0 || total > 1) {
                        errorArray.push('多个地址时，仅选一辆车')
                    }
                }
                if (errorArray.length > 0) {
                    message.error(errorArray.toString())
                    return;
                }
                //车辆类型
                const vehicleInfoPos = []
                if (values.vehicleTypes) {
                    values.vehicleTypes.forEach((type, i) => {
                        const po = {vehicleType: type, num: values.vehicleNums[i]}
                        vehicleInfoPos.push(po)
                    })
                }
                values.vehicleInfoPos = vehicleInfoPos
                delete values.vehicleTypes
                delete values.vehicleNums
            }
            //预计提货时间
            values.deliveryEstimateDt = values.deliveryEstimateDt ? values.deliveryEstimateDt.format('YYYY-MM-DD HH:mm:ss') : '';
            //起始地址 目的地址
            if (values.startAdressPos) {
                values.startAdressPos.forEach((value, i) => {
                    if (i === 0) {
                        values.originProvince = value.province
                        values.originCity = value.city
                    }
                    value.seqNo = i
                })
            }
            if (values.endAdressPos) {
                values.endAdressPos.forEach((value, i) => {
                    if (i === 0) {
                        values.destinationProvince = value.province
                        values.destinationCity = value.city
                    }
                    value.seqNo = i
                })
                saveTrackData(values)
            }
        });
    }
    const saveTrackData = async (data) => {
        if (order.id) {
            data.id = order.id;
            let result = await reqUpdateGnOrder(data)
            if (result.code === 200) {
                message.success(result.message)
                props.history.replace('/domesticList')
            } else {
                message.error(result.message)
            }
        } else {
            let result = await reqCreateGnOrder(data)
            if (result.code === 201) {
                message.success(result.message)
                props.history.replace('/domesticList')
            } else {
                message.error(result.message)
            }
        }
    }
    //增加地址
    const addAddr = (type) => {
        if (type === 'start') {
            const indx = startAdressPos.length - 1
            setStartAdressPos([...startAdressPos, {seqNo: indx}])
        } else {
            const indx = endAdressPos.length - 1
            setEndAdressPos([...endAdressPos, {seqNo: indx}])
        }
    }
    //删除地址
    const delAddr = (type, indx) => {
        if (type === 'start') {
            //修改地址数据源
            const startValues = props.form.getFieldValue('startAdressPos')
            const newAddrs = startValues.filter((o, i) => i !== indx)
            setStartAdressPos(newAddrs)
            //重置表单中的删除的地址数据
            newAddrs.forEach((o, i) => {
                const name = `startAdressPos[${i}]`;
                props.form.setFieldsValue({[name]: o})
            })
        } else {
            //修改地址数据源
            const endValue = props.form.getFieldValue('endAdressPos')
            const newAddrs = endValue.filter((o, i) => i !== indx)
            setEndAdressPos(newAddrs)
            //重置表单中的删除的地址数据
            newAddrs.forEach((o, i) => {
                const name = `endAdressPos[${i}]`;
                props.form.setFieldsValue({[name]: o})
            })
        }
    }
    //预计提货时间：提前48小时下单
    const disabledStartDate = (current) => {
        return current && current < moment().add('days', 1).endOf('day');
    };
    const disabledDateTime = (current) => {
        if (current && current < moment().add('days', 2).endOf('day')) {
            const hour = new Date().getHours();
            return {
                disabledHours: () => range(0, hour + 1),
            };
        }
    };
    //车辆类型
    const changeVehicleTypes = (checkedValues) => {
        setVehicleTypeValue(checkedValues)
    }
    //货物类型为“其他”时，需填写货物名称
    const changeGoodsTypes = (checkedValues) => {
        if (checkedValues.includes('other')) {
            setGoodsTypeOther(true)
        } else {
            setGoodsTypeOther(false)
        }
    }
    //合同弹层
    const clickContract = (flag = false) => {
        setVisibleContract(flag)
    }
    const listFormItemLayout = {
        labelCol: {lg: {span: 4}, md: {span: 8},},
        wrapperCol: {lg: {span: 20}, md: {span: 16},},
    }
    const vehicleFormItemLayout = {
        labelCol: {lg: {span: 9}, md: {span: 13},},
        wrapperCol: {lg: {span: 14}, md: {span: 10},},
    }
    const validateAgree = (rule, value, callback) => {
        if (rule.field === 'agree') {
            if (value === undefined || !value) {
                callback('请阅读并同意勾选电子合同');
            }
        }
        callback();
    }
    return (
        <div className='order-ticket box-shadow'>
            <div className="head-title">{order.id ? '修改' : '新建'}国内运输订单</div>
            <div className="order-ticket-content">
                <Form {...listFormItemLayout} onSubmit={handleSaveSubmit}>
                    <div className="order-spaceInfo-content">
                        {order.id && order.remark ?
                            <div className="back-error-tip">
                                <div>{order.remark}</div>
                            </div> : null}
                        <div className="strat-point">
                            <div className="sicon">起</div>
                            <div className="stext">起运地信息</div>
                        </div>
                        <div className='line-box'>
                            <div className='domestic-container'>
                                {startAdressPos.map((o, i) => {
                                    return <Address getFieldDecorator={getFieldDecorator}
                                                    setFieldsValue={setFieldsValue}
                                                    name={`startAdressPos[${i}]`} address={o} indx={i} type='start'
                                                    delAddr={delAddr}/>
                                })}
                                <Button className='whole' type="dashed" onClick={() => addAddr('start')}
                                        disabled={startAdressPos.length >= 3}><Icon type="plus"/>增加地址
                                </Button>
                            </div>
                        </div>
                        <div className="end-point">
                            <div className="eicon">终</div>
                            <div className="etext">目的地信息</div>
                        </div>
                        <div className="line-box2">
                            <div className='domestic-container'>
                                {endAdressPos.map((o, i) => {
                                    return <Address getFieldDecorator={getFieldDecorator}
                                                    setFieldsValue={setFieldsValue}
                                                    name={`endAdressPos[${i}]`} address={o} indx={i} type='end'
                                                    delAddr={delAddr}/>
                                })}
                                <Button className='whole' type="dashed" onClick={() => addAddr('end')}
                                        disabled={endAdressPos.length >= 3}><Icon type="plus"/>增加地址
                                </Button>
                            </div>
                        </div>
                        <div className='content-head-title'>其他信息</div>
                        <div className='spaceInfo-content-info domestic-container'>
                            {order.id ?
                                <Form.Item label="车辆类型">{getFieldDecorator('vehicleType', {
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Radio.Group>
                                    {convertToRadios(vehicleTypes, 'code', 'code', 'name')}
                                </Radio.Group>)}
                                </Form.Item>
                                : <Form.Item label="车辆类型">
                                    {getFieldDecorator('vehicleTypes', {
                                        rules: [{required: true, message: '该项必填'}]
                                    })(<Checkbox.Group onChange={changeVehicleTypes}>
                                        {convertToCheckboxes(vehicleTypes, 'code', 'code', 'name')}
                                    </Checkbox.Group>)}
                                    {vehicleTypeValue.length > 0 ?
                                        <div className='domestic-margin domestic-box'>
                                            {vehicleTypeValue.map((o, i) => {
                                                return <Form.Item label={o + " 订车数量"} {...vehicleFormItemLayout}>
                                                    {getFieldDecorator(`vehicleNums[${i}]`, {
                                                        rules: [{required: true, message: '该项必填'}]
                                                    })(<InputNumber className='whole' min={0} max={10} step={1}
                                                                    precision={0}/>)}
                                                </Form.Item>
                                            })}
                                        </div> : null}
                                </Form.Item>}
                            <Form.Item label="预计提货时间">
                                {getFieldDecorator('deliveryEstimateDt', {
                                    rules: [{required: true, message: '该项必填'}],
                                })(<DatePicker className='whole'
                                               format="YYYY-MM-DD HH"
                                               disabledDate={disabledStartDate}
                                               disabledTime={disabledDateTime}
                                               showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                />)}
                            </Form.Item>
                            <Form.Item label="保险">
                                {getFieldDecorator('insureFeeType', {
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Radio.Group>
                                    <Radio value='D'>我司代办</Radio>
                                    <Radio value='Z'>自办</Radio>
                                </Radio.Group>)}
                            </Form.Item>
                            <Form.Item label="货物类型">
                                {getFieldDecorator('goodsTypes')(
                                    <Checkbox.Group onChange={changeGoodsTypes}>
                                        {convertToCheckboxes(goodsTypes, 'code', 'code', 'name')}
                                        <Checkbox value='other'>其他</Checkbox>
                                        {goodsTypeOther ? getFieldDecorator('goodsName', {
                                            rules: [{required: true, message: '货物类型名称必填'}]
                                        })(<Input placeholder='请输入货物类型名称' style={{width: '200px'}}></Input>) : null}
                                    </Checkbox.Group>
                                )}
                            </Form.Item>
                            <Form.Item label="包装方式">
                                {getFieldDecorator('packageTypes')(<Checkbox.Group>
                                    {convertToCheckboxes(packageTypes, 'code', 'code', 'name')}
                                </Checkbox.Group>)}
                            </Form.Item>
                            <Form.Item label="电子合同">
                                {getFieldDecorator('agree', {
                                    rules: [{required: true, message: '该项必填'}, {validator: validateAgree}]
                                })(<Checkbox> 我同意<a
                                    onClick={() => clickContract(true)}>《呜呜网国内车货物规范协议》</a></Checkbox>)}
                            </Form.Item>
                        </div>
                    </div>
                    <div className='box-submit'>
                        <AuthFormItem authority="order_start:commit">
                            <Button type="primary" htmlType="submit" style={{marginRight: '10px'}}>保存</Button>
                        </AuthFormItem>
                    </div>
                </Form>
            </div>
            <ContractModal onCancel={clickContract} view={visibleContract}/>
        </div>
    )
}

const DomesticOrderForm = authorizePage("order_start:commit")(Form.create()(DomesticOrder))
export default DomesticOrderForm